export enum BaleTypeEnum {
    Export = 'Export',
    Production = 'Production',
    
}